// Generated by ts-to-zod
import { z } from 'zod'
export const PayloadSupportedTimezones = z.union([
  z.literal('Pacific/Midway'),
  z.literal('Pacific/Niue'),
  z.literal('Pacific/Honolulu'),
  z.literal('Pacific/Rarotonga'),
  z.literal('America/Anchorage'),
  z.literal('Pacific/Gambier'),
  z.literal('America/Los_Angeles'),
  z.literal('America/Tijuana'),
  z.literal('America/Denver'),
  z.literal('America/Phoenix'),
  z.literal('America/Chicago'),
  z.literal('America/Guatemala'),
  z.literal('America/New_York'),
  z.literal('America/Bogota'),
  z.literal('America/Caracas'),
  z.literal('America/Santiago'),
  z.literal('America/Buenos_Aires'),
  z.literal('America/Sao_Paulo'),
  z.literal('Atlantic/South_Georgia'),
  z.literal('Atlantic/Azores'),
  z.literal('Atlantic/Cape_Verde'),
  z.literal('Europe/London'),
  z.literal('Europe/Berlin'),
  z.literal('Africa/Lagos'),
  z.literal('Europe/Athens'),
  z.literal('Africa/Cairo'),
  z.literal('Europe/Moscow'),
  z.literal('Asia/Riyadh'),
  z.literal('Asia/Dubai'),
  z.literal('Asia/Baku'),
  z.literal('Asia/Karachi'),
  z.literal('Asia/Tashkent'),
  z.literal('Asia/Calcutta'),
  z.literal('Asia/Dhaka'),
  z.literal('Asia/Almaty'),
  z.literal('Asia/Jakarta'),
  z.literal('Asia/Bangkok'),
  z.literal('Asia/Shanghai'),
  z.literal('Asia/Singapore'),
  z.literal('Asia/Tokyo'),
  z.literal('Asia/Seoul'),
  z.literal('Australia/Brisbane'),
  z.literal('Australia/Sydney'),
  z.literal('Pacific/Guam'),
  z.literal('Pacific/Noumea'),
  z.literal('Pacific/Auckland'),
  z.literal('Pacific/Fiji'),
])

export const PayloadAdmin = z.object({
  id: z.string(),
  updatedAt: z.string(),
  createdAt: z.string(),
  email: z.string(),
  resetPasswordToken: z.string().optional(),
  resetPasswordExpiration: z.string().optional(),
  salt: z.string().optional(),
  hash: z.string().optional(),
  loginAttempts: z.number().optional(),
  lockUntil: z.string().optional(),
  sessions: z.array(
    z.object({
      id: z.string(),
      createdAt: z.string().optional(),
      expiresAt: z.string(),
    }),
  ),
  password: z.string().optional(),
})

export const PayloadUserAuth = z.object({
  id: z.string(),
  encryptedPid: z.string(),
  pidLookupHash: z.string(),
  type: z.literal('bankid'),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadMunicipality = z.object({
  id: z.string(),
  name: z.string(),
  links: z.object({
    domainUrl: z.string(),
    lssInformationUrl: z.string().optional(),
    lssApplicationUrl: z.string().optional(),
  }),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadServiceGroup = z.object({
  id: z.string(),
  _order: z.string().optional(),
  title: z.string(),
  description: z.string(),
  showMunicipalityLinks: z.boolean(),
  active: z.boolean(),
  validationPrompt: z.string().optional(),
  links: z.array(
    z.object({
      label: z.string(),
      url: z.string(),
      id: z.string().optional(),
    }),
  ),
  services: z.array(
    z.object({
      title: z.string(),
      description: z.string(),
      id: z.string(),
      active: z.boolean(),
      validationPrompt: z.string().optional().nullable(),
    }),
  ),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadMedia = z.object({
  id: z.string(),
  alt: z.string(),
  updatedAt: z.string(),
  createdAt: z.string(),
  url: z.string().optional(),
  thumbnailURL: z.string().optional(),
  filename: z.string().optional(),
  mimeType: z.string().optional(),
  filesize: z.number().optional(),
  width: z.number().optional(),
  height: z.number().optional(),
  focalX: z.number().optional(),
  focalY: z.number().optional(),
})

export const PayloadPayloadKv = z.object({
  id: z.string(),
  key: z.string(),
  data: z
    .union([
      z.record(z.string(), z.unknown()),
      z.array(z.unknown()),
      z.string(),
      z.number(),
      z.boolean(),
    ])
    .nullable(),
})

export const PayloadUser = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().optional(),
  displayName: z.string().optional(),
  pid: z.string(),
  get auth() {
    return z.union([z.string(), PayloadUserAuth])
  },
  individuals: z
    .object({
      get docs() {
        return z.array(z.union([z.string(), PayloadIndividual])).optional()
      },
      hasNextPage: z.boolean().optional(),
      totalDocs: z.number().optional(),
    })
    .optional(),
  lastLogin: z.string().optional(),
  stripeCustomerId: z.string().optional(),
  flags: z.array(z.enum(['ambassador', 'journalist', 'media', 'tester'])).optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadIndividual = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  gender: z.union([z.literal('male'), z.literal('female'), z.literal('other')]).optional(),
  get municipality() {
    return z.union([z.string(), PayloadMunicipality])
  },
  pid: z.string(),
  birthDate: z.string(),
  encryptedPid: z.string(),
  generatedDescription: z
    .object({
      short: z
        .object({
          result: z.string().optional(),
          updatedAt: z.string().optional(),
          version: z.string().optional(),
        })
        .optional(),
      detail: z
        .object({
          result: z.string().optional(),
          updatedAt: z.string().optional(),
          version: z.string().optional(),
        })
        .optional(),
    })
    .optional(),
  regen: z
    .object({
      status: z
        .union([z.literal('idle'), z.literal('running'), z.literal('done'), z.literal('error')])
        .optional(),
      lastRegeneratedAt: z.string().optional(),
      startedAt: z.string().optional(),
      stale: z.boolean().optional(),
      staleSince: z.string().optional(),
      error: z.string().optional(),
      workOrderId: z.string().optional(),
    })
    .optional(),
  users: z.array(
    z.object({
      get user() {
        return z.union([z.string(), PayloadUser])
      },
      roles: z.array(z.literal('admin')).optional(),
      relation: z.union([
        z.literal('parent'),
        z.literal('sibling'),
        z.literal('grandparent'),
        z.literal('personal_assistant'),
        z.literal('foster_family'),
        z.literal('housing_support'),
        z.literal('self'),
        z.literal('other'),
      ]),
      relationOther: z.string().optional(),
      isGuardian: z.boolean().optional(),
      isLegalRepresentative: z.boolean().optional(),
      id: z.string().optional(),
    }),
  ),
  documents: z
    .object({
      get docs() {
        return z.array(z.union([z.string(), PayloadDocument])).optional()
      },
      hasNextPage: z.boolean().optional(),
      totalDocs: z.number().optional(),
    })
    .optional(),
  entitlement: z
    .object({
      get docs() {
        return z.array(z.union([z.string(), PayloadEntitlement])).optional()
      },
      hasNextPage: z.boolean().optional(),
      totalDocs: z.number().optional(),
    })
    .optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadDocument = z.object({
  id: z.string(),
  name: z.string(),
  mimeType: z.string().optional(),
  type: z.union([
    z.literal('application'),
    z.literal('certificate'),
    z.literal('decision'),
    z.literal('diagnosis'),
    z.literal('document'),
    z.literal('prescription'),
    z.literal('report'),
    z.literal('unknown'),
  ]),
  diagnoses: z.array(z.string()),
  status: z.union([
    z.literal('draft'),
    z.literal('waiting_for_upload'),
    z.literal('uploaded'),
    z.literal('parsing'),
    z.literal('analyzing'),
    z.literal('embedding'),
    z.literal('done'),
    z.literal('error'),
  ]),
  filePath: z.string().optional(),
  files: z.array(
    z.object({
      name: z.string(),
      originalName: z.string(),
      filePath: z.string(),
      mimeType: z.string(),
      bytes: z.number(),
      order: z.number(),
      checksum: z.string().optional(),
      uploadStatus: z.union([z.literal('pending'), z.literal('uploaded'), z.literal('failed')]),
      id: z.string().optional(),
    }),
  ),
  combinedFilePath: z.string().optional(),
  preChecks: z
    .object({
      status: z.union([z.literal('pending'), z.literal('passed'), z.literal('warning')]).optional(),
      results: z
        .union([
          z.record(z.string(), z.unknown()),
          z.array(z.unknown()),
          z.string(),
          z.number(),
          z.boolean(),
        ])
        .optional(),
    })
    .optional(),
  get individual() {
    return z.union([z.string(), PayloadIndividual])
  },
  errand: z
    .object({
      get docs() {
        return z.array(z.union([z.string(), PayloadErrand])).optional()
      },
      hasNextPage: z.boolean().optional(),
      totalDocs: z.number().optional(),
    })
    .optional(),
  summaries: z
    .object({
      brief: z
        .object({
          result: z.string().optional(),
          updatedAt: z.string().optional(),
          version: z.string().optional(),
        })
        .optional(),
      comprehensive: z
        .object({
          result: z.string().optional(),
          updatedAt: z.string().optional(),
          version: z.string().optional(),
        })
        .optional(),
      headline: z
        .object({
          result: z.string().optional(),
          updatedAt: z.string().optional(),
          version: z.string().optional(),
        })
        .optional(),
      simple: z
        .object({
          result: z.string().optional(),
          updatedAt: z.string().optional(),
          version: z.string().optional(),
        })
        .optional(),
    })
    .optional(),
  bytes: z.number().optional(),
  checksum: z.string().optional(),
  instance: z.string().optional(),
  categoryTags: z.array(
    z.union([
      z.literal('communication_language'),
      z.literal('emotions_behaviors'),
      z.literal('health_care'),
      z.literal('home'),
      z.literal('leisure_social'),
      z.literal('motor_function'),
      z.literal('school_work_daily'),
      z.literal('support_authorities'),
    ]),
  ),
  categories: z.array(
    z.object({
      category: z
        .union([
          z.literal('communication_language'),
          z.literal('emotions_behaviors'),
          z.literal('health_care'),
          z.literal('home'),
          z.literal('leisure_social'),
          z.literal('motor_function'),
          z.literal('school_work_daily'),
          z.literal('support_authorities'),
        ])
        .optional(),
      description: z.string().optional(),
      id: z.string().optional(),
    }),
  ),
  userTags: z.array(
    z.object({
      tag: z.string().optional(),
      id: z.string().optional(),
    }),
  ),
  issuanceAt: z.string().optional(),
  issuers: z.array(
    z.object({
      name: z.string().optional(),
      original_role: z.string().optional(),
      role: z
        .union([
          z.literal('case_manager'),
          z.literal('legal_professional'),
          z.literal('physician'),
          z.literal('psychologist'),
          z.literal('therapist'),
        ])
        .optional(),
      id: z.string().optional(),
    }),
  ),
  activities: z.array(
    z.object({
      description: z.string().optional(),
      date: z.string().optional(),
      year: z.number(),
      month: z.number().optional(),
      day: z.number().optional(),
      reference: z
        .union([
          z.literal('application'),
          z.literal('certificate'),
          z.literal('decision'),
          z.literal('diagnosis'),
          z.literal('document'),
          z.literal('prescription'),
          z.literal('report'),
          z.literal('unknown'),
        ])
        .optional(),
      type: z
        .union([
          z.literal('application'),
          z.literal('birth'),
          z.literal('birthday'),
          z.literal('certificate'),
          z.literal('decision'),
          z.literal('diagnosis'),
          z.literal('document'),
          z.literal('life-event'),
          z.literal('prescription'),
          z.literal('report'),
          z.literal('unknown'),
        ])
        .optional(),
      id: z.string().optional(),
    }),
  ),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadErrand = z.object({
  id: z.string(),
  title: z.string(),
  generatedFields: z
    .object({
      summary: z.string().optional(),
    })
    .optional(),
  get thread() {
    return z.union([z.string(), PayloadThread])
  },
  get documents() {
    return z.array(z.union([z.string(), PayloadDocument]))
  },
  get notes() {
    return z.array(z.union([z.string(), PayloadNote]))
  },
  get individual() {
    return z.union([z.string(), PayloadIndividual])
  },
  get user() {
    return z.union([z.string(), PayloadUser])
  },
  status: z.union([
    z.literal('started'),
    z.literal('submitted'),
    z.literal('approved'),
    z.literal('rejected'),
  ]),
  statusHistory: z.array(
    z.object({
      status: z.union([
        z.literal('started'),
        z.literal('submitted'),
        z.literal('approved'),
        z.literal('rejected'),
      ]),
      changedAt: z.string(),
      get changedBy() {
        return z.union([z.string().nullable(), PayloadUser]).optional()
      },
      id: z.string().optional(),
    }),
  ),
  serviceGroups: z.array(
    z.object({
      get serviceGroup() {
        return z.union([z.string(), PayloadServiceGroup])
      },
      services: z
        .array(
          z.object({
            serviceId: z.string(),
            id: z.string().optional(),
          }),
        )
        .optional(),
      id: z.string().optional(),
    }),
  ),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadThread = z.object({
  id: z.string(),
  title: z.string().optional(),
  summary: z.string().optional(),
  generatedMessageCount: z.number().optional(),
  type: z.union([z.literal('conversation'), z.literal('errand')]),
  get individual() {
    return z.union([z.string(), PayloadIndividual])
  },
  get user() {
    return z.union([z.string(), PayloadUser])
  },
  get note() {
    return z.union([z.string().nullable(), PayloadNote]).optional()
  },
  messages: z.array(
    z.object({
      messageId: z.string().optional(),
      role: z.union([z.literal('user'), z.literal('assistant'), z.literal('system')]),
      parts: z
        .union([
          z.record(z.string(), z.unknown()),
          z.array(z.unknown()),
          z.string(),
          z.number(),
          z.boolean(),
        ])
        .nullable(),
      usage: z
        .union([
          z.record(z.string(), z.unknown()),
          z.array(z.unknown()),
          z.string(),
          z.number(),
          z.boolean(),
        ])
        .optional(),
      metadata: z
        .union([
          z.record(z.string(), z.unknown()),
          z.array(z.unknown()),
          z.string(),
          z.number(),
          z.boolean(),
        ])
        .optional(),
      id: z.string().optional(),
    }),
  ),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadNote = z.object({
  id: z.string(),
  title: z.string().optional(),
  get individual() {
    return z.union([z.string(), PayloadIndividual])
  },
  get user() {
    return z.union([z.string(), PayloadUser])
  },
  relationTo: z
    .object({
      relationTo: z.literal('threads'),
      get value() {
        return z.union([z.string(), PayloadThread])
      },
    })
    .optional(),
  errand: z
    .object({
      get docs() {
        return z.array(z.union([z.string(), PayloadErrand])).optional()
      },
      hasNextPage: z.boolean().optional(),
      totalDocs: z.number().optional(),
    })
    .optional(),
  note: z.string(),
  contentChecksum: z.string().optional(),
  titleIsManual: z.boolean().optional(),
  generationStatus: z
    .union([z.literal('idle'), z.literal('generating'), z.literal('done'), z.literal('error')])
    .optional(),
  activities: z.array(
    z.object({
      description: z.string().optional(),
      date: z.string().optional(),
      year: z.number(),
      month: z.number().optional(),
      day: z.number().optional(),
      reference: z
        .union([
          z.literal('application'),
          z.literal('certificate'),
          z.literal('decision'),
          z.literal('diagnosis'),
          z.literal('document'),
          z.literal('prescription'),
          z.literal('report'),
          z.literal('unknown'),
        ])
        .optional(),
      type: z
        .union([
          z.literal('application'),
          z.literal('birth'),
          z.literal('birthday'),
          z.literal('certificate'),
          z.literal('decision'),
          z.literal('diagnosis'),
          z.literal('document'),
          z.literal('life-event'),
          z.literal('prescription'),
          z.literal('report'),
          z.literal('unknown'),
        ])
        .optional(),
      id: z.string().optional(),
    }),
  ),
  pendingEvents: z.array(
    z.object({
      description: z.string(),
      timeText: z.string(),
      year: z.number().optional(),
      month: z.number().optional(),
      type: z
        .union([
          z.literal('application'),
          z.literal('birth'),
          z.literal('birthday'),
          z.literal('certificate'),
          z.literal('decision'),
          z.literal('diagnosis'),
          z.literal('document'),
          z.literal('life-event'),
          z.literal('prescription'),
          z.literal('report'),
          z.literal('unknown'),
        ])
        .optional(),
      id: z.string().optional(),
    }),
  ),
  embedding: z.array(z.number()),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadWorkOrder = z.object({
  id: z.string(),
  type: z.union([
    z.literal('document'),
    z.literal('document-pre-checks'),
    z.literal('individual-description'),
    z.literal('thread-summary'),
    z.literal('service-group-recommendations'),
    z.literal('note'),
    z.literal('individual-regen'),
    z.literal('errand-upload'),
    z.literal('errand-reaction'),
  ]),
  version: z.string(),
  individual: z.string(),
  relationTo: z.union([
    z.object({
      relationTo: z.literal('documents'),
      get value() {
        return z.union([z.string(), PayloadDocument])
      },
    }),
    z.object({
      relationTo: z.literal('errands'),
      get value() {
        return z.union([z.string(), PayloadErrand])
      },
    }),
    z.object({
      relationTo: z.literal('individuals'),
      get value() {
        return z.union([z.string(), PayloadIndividual])
      },
    }),
    z.object({
      relationTo: z.literal('threads'),
      get value() {
        return z.union([z.string(), PayloadThread])
      },
    }),
  ]),
  status: z.union([
    z.literal('pending'),
    z.literal('in-progress'),
    z.literal('completed'),
    z.literal('failed'),
  ]),
  jobs: z.record(
    z.string(),
    z.object({
      runtime: z.number().optional(),
      status: z.union([z.literal('pending'), z.literal('completed'), z.literal('failed')]),
      usage: z
        .object({
          inputTokens: z.number().optional(),
          inputTokenDetails: z
            .object({
              noCacheTokens: z.number().optional(),
              cacheReadTokens: z.number().optional(),
              cacheWriteTokens: z.unknown().optional(),
            })
            .optional(),
          outputTokens: z.number().optional(),
          outputTokenDetails: z
            .object({
              textTokens: z.number().optional(),
              reasoningTokens: z.number().optional(),
            })
            .optional(),
          totalTokens: z.number().optional(),
          raw: z.unknown().optional(),
          reasoningTokens: z.number().optional(),
          cachedInputTokens: z.number().optional(),
        })
        .optional(),
      metadata: z.record(z.string(), z.unknown()).optional(),
    }),
  ),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadServiceGroupGeneration = z.object({
  id: z.string(),
  get serviceGroup() {
    return z.union([z.string(), PayloadServiceGroup])
  },
  get individual() {
    return z.union([z.string(), PayloadIndividual])
  },
  explanation: z.string(),
  met: z.union([z.literal('recommended'), z.literal('uncertain'), z.literal('not_recommended')]),
  services: z.array(
    z.object({
      id: z.string(),
      explanation: z.string(),
      met: z.union([
        z.literal('recommended'),
        z.literal('uncertain'),
        z.literal('not_recommended'),
      ]),
    }),
  ),
  lastRun: z
    .object({
      met: z
        .union([z.literal('recommended'), z.literal('uncertain'), z.literal('not_recommended')])
        .optional(),
      generatedAt: z.string().optional(),
      services: z
        .array(
          z.object({
            id: z.string(),
            met: z
              .union([
                z.literal('recommended'),
                z.literal('uncertain'),
                z.literal('not_recommended'),
              ])
              .optional(),
          }),
        )
        .optional(),
    })
    .optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadErrandAction = z.object({
  id: z.string(),
  get errand() {
    return z.union([z.string(), PayloadErrand])
  },
  get individual() {
    return z.union([z.string(), PayloadIndividual])
  },
  get user() {
    return z.union([z.string(), PayloadUser])
  },
  type: z.union([z.literal('email-draft'), z.literal('text-draft')]),
  title: z.string(),
  content: z.string().optional(),
  metadata: z
    .union([
      z.record(z.string(), z.unknown()),
      z.array(z.unknown()),
      z.string(),
      z.number(),
      z.boolean(),
    ])
    .optional(),
  get sourceThread() {
    return z.union([z.string().nullable(), PayloadThread]).optional()
  },
  sourceMessageId: z.string().optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadFeedback = z.object({
  id: z.string(),
  text: z.string(),
  email: z.string().optional(),
  get user() {
    return z.union([z.string().nullable(), PayloadUser]).optional()
  },
  userAgent: z.string().optional(),
  url: z.string().optional(),
  slack: z
    .union([
      z.record(z.string(), z.unknown()),
      z.array(z.unknown()),
      z.string(),
      z.number(),
      z.boolean(),
    ])
    .optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadContact = z.object({
  id: z.string(),
  get individual() {
    return z.union([z.string(), PayloadIndividual])
  },
  name: z.string(),
  organization: z.string().optional(),
  role: z
    .union([
      z.literal('case_manager'),
      z.literal('legal_professional'),
      z.literal('physician'),
      z.literal('psychologist'),
      z.literal('therapist'),
      z.literal('specialist_physician'),
      z.literal('nurse'),
      z.literal('special_educator'),
      z.literal('personal_assistant'),
      z.literal('coordinator'),
      z.literal('administrator'),
      z.literal('relative'),
      z.literal('other'),
    ])
    .optional(),
  originalRole: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().optional(),
  address: z.string().optional(),
  notes: z.string().optional(),
  origin: z.union([z.literal('ai'), z.literal('manual')]),
  matchKey: z.string().optional(),
  lockedFields: z.array(
    z.union([
      z.literal('name'),
      z.literal('role'),
      z.literal('originalRole'),
      z.literal('organization'),
      z.literal('phone'),
      z.literal('email'),
      z.literal('address'),
    ]),
  ),
  sources: z.array(
    z.object({
      get document() {
        return z.union([z.string(), PayloadDocument])
      },
      rawText: z.string().optional(),
      foundAt: z.string().optional(),
      id: z.string().optional(),
    }),
  ),
  isArchived: z.boolean().optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

// ─── Billing ──────────────────────────────────────────────────────────────────
// Hand-maintained, like everything above: ts-to-zod breaks on the generics in
// payload-types.ts. Keep these in step with the generated interfaces by hand.

export const PayloadOrganization = z.object({
  id: z.string(),
  name: z.string(),
  organizationNumber: z.string().optional(),
  billingEmail: z.string().optional(),
  contactName: z.string().optional(),
  notes: z.string().optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadLicenseAgreement = z.object({
  id: z.string(),
  get organization() {
    return z.union([z.string(), PayloadOrganization])
  },
  seats: z.number(),
  status: z.union([z.literal('draft'), z.literal('active'), z.literal('expired')]),
  startsAt: z.string(),
  endsAt: z.string(),
  recurring: z.boolean().optional(),
  interval: z.union([z.literal('month'), z.literal('year')]).optional(),
  reference: z.string().optional(),
  pricePerSeat: z.number().optional(),
  currency: z.string().optional(),
  notes: z.string().optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadSubscription = z.object({
  id: z.string(),
  provider: z.union([z.literal('manual'), z.literal('stripe')]),
  status: z.union([
    z.literal('trialing'),
    z.literal('active'),
    z.literal('past_due'),
    z.literal('canceled'),
    z.literal('expired'),
  ]),
  get owner() {
    return z.union([z.string(), PayloadUser]).optional()
  },
  get organization() {
    return z.union([z.string(), PayloadOrganization]).optional()
  },
  get licenseAgreement() {
    return z.union([z.string(), PayloadLicenseAgreement]).optional()
  },
  seats: z.number(),
  interval: z.union([z.literal('month'), z.literal('year')]),
  recurring: z.boolean().optional(),
  startedAt: z.string().optional(),
  currentPeriodEnd: z.string().optional(),
  cancelAtPeriodEnd: z.boolean().optional(),
  providerCustomerId: z.string().optional(),
  providerSubscriptionId: z.string().optional(),
  providerSessionId: z.string().optional(),
  providerPriceId: z.string().optional(),
  providerMeta: z.any().optional(),
  lastEventId: z.string().optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadEntitlement = z.object({
  id: z.string(),
  get individual() {
    return z.union([z.string(), PayloadIndividual])
  },
  source: z.union([z.literal('direct'), z.literal('license'), z.literal('manual')]),
  status: z.union([
    z.literal('trialing'),
    z.literal('active'),
    z.literal('past_due'),
    z.literal('canceled'),
    z.literal('expired'),
  ]),
  get owner() {
    return z.union([z.string(), PayloadUser]).optional()
  },
  get subscription() {
    return z.union([z.string(), PayloadSubscription]).optional()
  },
  currentPeriodEnd: z.string().optional(),
  notes: z.string().optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})

export const PayloadPayment = z.object({
  id: z.string(),
  get subscription() {
    return z.union([z.string(), PayloadSubscription]).optional()
  },
  provider: z.union([z.literal('manual'), z.literal('stripe')]),
  status: z.union([
    z.literal('pending'),
    z.literal('paid'),
    z.literal('failed'),
    z.literal('refunded'),
  ]),
  paidAt: z.string().optional(),
  amountTotal: z.number().optional(),
  amountTax: z.number().optional(),
  currency: z.string().optional(),
  taxRate: z.number().optional(),
  taxabilityReason: z.string().optional(),
  providerInvoiceId: z.string().optional(),
  providerPaymentIntentId: z.string().optional(),
  invoiceUrl: z.string().optional(),
  receiptUrl: z.string().optional(),
  providerEventId: z.string().optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
})
